import React from 'react';

import { CollectionChainType } from '@app/client';
import { CollectionLink } from '@app/pages/Collection/components/CollectionLink';
import { HoverUnderline } from '@app/pages/NFTDetailView/components/MainStage/components/NFTInfo/styles';

import { CardChainIcon } from '../CardChainIcon';

import { AssetCount, CollectionName, Info, Thumbnail, ThumbnailSkeleton, VerifiedBadge, Wrapper } from './styles';

interface CardCollectionNameProps {
    slug?: string | null;
    name?: string;
    image?: string;
    collectionTokenCount?: number;
    hideLink?: boolean;
    chain?: CollectionChainType;
    disablePeek?: boolean;
    isFantasy?: boolean;
}

export const CardCollectionName = ({
    slug,
    name,
    disablePeek = false,
    hideLink = false,
    image,
    isFantasy = false,
    collectionTokenCount,
    chain = CollectionChainType.Ethereum,
}: CardCollectionNameProps) => {
    const _token_count = collectionTokenCount || null;
    const isVerified = false; // We need BE to add Verified boolean to collection metadata

    const thumbnailMarkup = hideLink ? (
        <Thumbnail title={name || ''} $image={image}>
            {isVerified && <VerifiedBadge />}
        </Thumbnail>
    ) : (
        <CollectionLink slug={slug} chain={chain} disablePeek={disablePeek}>
            <Thumbnail title={name || ''} $image={image}>
                {isVerified && <VerifiedBadge />}
            </Thumbnail>
        </CollectionLink>
    );
    const imageMarkup = image ? thumbnailMarkup : <ThumbnailSkeleton />;

    return (
        <Wrapper>
            {isFantasy ? null : imageMarkup}
            <Info>
                {name && (
                    <CollectionName title={name}>
                        {hideLink ? (
                            name
                        ) : (
                            <CollectionLink slug={slug} chain={chain} disablePeek={disablePeek}>
                                {name}
                                <HoverUnderline />
                            </CollectionLink>
                        )}
                    </CollectionName>
                )}
                {Boolean(_token_count) && <AssetCount>{_token_count}</AssetCount>}
            </Info>

            {chain && slug && <CardChainIcon chain={chain} />}
        </Wrapper>
    );
};
